import { offerAiPrompts, offerAiPromptVersions } from '@markku/db'
import { createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectOfferAiPromptSchema = createSelectSchema(
  offerAiPrompts,
).omit({
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export const selectOfferAiPromptVersionSchema = createSelectSchema(
  offerAiPromptVersions,
).omit({
  updatedAt: true,
  deletedAt: true,
})

export const offerAiPromptKindSchema = z.enum(['suggestion', 'cover'])
export type OfferAiPromptKind = z.infer<typeof offerAiPromptKindSchema>

export const upsertOfferAiPromptSchema = z.object({
  kind: offerAiPromptKindSchema,
  systemInstructions: z.string().trim().min(1, 'Prompt cannot be empty'),
})

// Dry-run is suggestion-only — cover prompt has its own deterministic
// downstream (subject + body) and no opportunity-context dependency that
// the admin needs to test interactively.
export const dryRunOfferAiPromptSchema = z.object({
  systemInstructions: z.string().trim().min(1, 'Prompt cannot be empty'),
  opportunityId: z.number(),
})

export const rollbackOfferAiPromptSchema = z.object({
  versionId: z.number(),
})

export type OfferAiPrompt = z.infer<typeof selectOfferAiPromptSchema>
export type OfferAiPromptVersion = z.infer<
  typeof selectOfferAiPromptVersionSchema
>
export type UpsertOfferAiPromptInput = z.infer<typeof upsertOfferAiPromptSchema>
export type DryRunOfferAiPromptInput = z.infer<typeof dryRunOfferAiPromptSchema>
